
export interface ISortSettingInstance {
	table: string;
	field: string;
	type: string;
	order: string;
}

export interface ISortFieldInstance {
	[field: string]: ISortSettingInstance;
}

export interface ISortTableInstance {
	[table: string]: ISortFieldInstance;
}

export class SortService {

	private instances: ISortTableInstance = {};

	public save(instance: ISortSettingInstance) {
		let field: ISortFieldInstance = {};
		field[instance.field] = instance;
		if (instance.order === 'null') {
			delete this.instances[instance.table][instance.field];
		} else {
			if (!this.instances[instance.table]) {
				this.instances[instance.table] = field;
			} else {
				this.instances[instance.table][instance.field] = instance;
			}
		}
	}

	public getInstances(): any {
		return this.instances;
	}

	public searchInstance(table: string): ISortFieldInstance {
		return this.instances[table];
	}

	public sortCollection(collection: any, table: string): any {
		let fields = this.instances[table];
		collection.sort(sortFunc);
		function sortFunc(a: any, b: any): number {
			for (let field in fields) {
				let fName = fields[field]['field'];
				let order = fields[field]['order'];
				let type = fields[field]['type'];
				let compA = a[fName];
				let compB = b[fName];
				if (type === 'string') {
					compA = compA.toLowerCase();
					compB = compB.toLowerCase();
				}
				if (compA !== compB) {
					if (order === 'asc') {
						return (compA < compB) ? -1 : 1;
					} else {
						return (compA < compB) ? 1 : -1;
					}
				}
			}
			return 0;
		}
		return collection;

	}
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/sort/sort-service.ts
 **/